 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"Activated~Administrator~Audit Actions~Credits~Customer~Dashboard~LocationOverall~Main~MyPrezence~Onb~9d88553d":"Activated~Administrator~Audit Actions~Credits~Customer~Dashboard~LocationOverall~Main~MyPrezence~Onb~9d88553d","Activated~Administrator~Audit Actions~Credits~Customer~Dashboard~LocationOverall~MyPrezence~Onboarde~aac36c5a":"Activated~Administrator~Audit Actions~Credits~Customer~Dashboard~LocationOverall~MyPrezence~Onboarde~aac36c5a","Activated~Administrator~Audit Actions~Credits~Customer~LocationOverall~MyPrezence~Onboarded~Prezence~7f307219":"Activated~Administrator~Audit Actions~Credits~Customer~LocationOverall~MyPrezence~Onboarded~Prezence~7f307219","Activated~Credits~Customer~Dashboard~Onboarded~Prospect~Transactions":"Activated~Credits~Customer~Dashboard~Onboarded~Prospect~Transactions","Activated":"Activated","Credits":"Credits","Customer":"Customer","Onboarded":"Onboarded","Prospect":"Prospect","Transactions":"Transactions","Administrator":"Administrator","Audit Actions":"Audit Actions","Dashboard~releaseView":"Dashboard~releaseView","releaseView":"releaseView","LocationOverall":"LocationOverall","MyPrezence":"MyPrezence","Prezence":"Prezence","Printed":"Printed","Produced":"Produced","Referrals":"Referrals","Resolved Swipes":"Resolved Swipes","SalesRep":"SalesRep","Dashboard":"Dashboard","Main":"Main"}[chunkId]||chunkId) + "." + {"Activated~Administrator~Audit Actions~Credits~Customer~Dashboard~LocationOverall~Main~MyPrezence~Onb~9d88553d":"6e1de7e5","Activated~Administrator~Audit Actions~Credits~Customer~Dashboard~LocationOverall~MyPrezence~Onboarde~aac36c5a":"bf1208bf","Activated~Administrator~Audit Actions~Credits~Customer~LocationOverall~MyPrezence~Onboarded~Prezence~7f307219":"8ce1160e","Activated~Credits~Customer~Dashboard~Onboarded~Prospect~Transactions":"4a251772","Activated":"d52ace1e","Credits":"6938d40c","Customer":"5e01d79f","Onboarded":"e1ecc9db","Prospect":"4d933243","Transactions":"2854a708","Administrator":"1cc53351","Audit Actions":"6c971abb","Dashboard~releaseView":"d5186e78","releaseView":"f124f91e","LocationOverall":"a528c8e6","MyPrezence":"5289e91e","Prezence":"07840b97","Printed":"56b1fe00","Produced":"953311c5","Referrals":"8d8945c0","Resolved Swipes":"4037f98b","SalesRep":"21cfe6f2","Dashboard":"9586adac","Main":"e49396f0","chunk-41e00dab":"0d702f65","chunk-2bbf3d76":"c06f63e1","chunk-2d0a4d8f":"72df1253"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"Activated~Administrator~Audit Actions~Credits~Customer~Dashboard~LocationOverall~Main~MyPrezence~Onb~9d88553d":1,"Activated~Administrator~Audit Actions~Credits~Customer~Dashboard~LocationOverall~MyPrezence~Onboarde~aac36c5a":1,"Activated~Administrator~Audit Actions~Credits~Customer~LocationOverall~MyPrezence~Onboarded~Prezence~7f307219":1,"Activated":1,"Credits":1,"Customer":1,"Onboarded":1,"Prospect":1,"Transactions":1,"Administrator":1,"Audit Actions":1,"Dashboard~releaseView":1,"releaseView":1,"MyPrezence":1,"Prezence":1,"Printed":1,"Produced":1,"Referrals":1,"Resolved Swipes":1,"SalesRep":1,"Dashboard":1,"Main":1,"chunk-41e00dab":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"Activated~Administrator~Audit Actions~Credits~Customer~Dashboard~LocationOverall~Main~MyPrezence~Onb~9d88553d":"Activated~Administrator~Audit Actions~Credits~Customer~Dashboard~LocationOverall~Main~MyPrezence~Onb~9d88553d","Activated~Administrator~Audit Actions~Credits~Customer~Dashboard~LocationOverall~MyPrezence~Onboarde~aac36c5a":"Activated~Administrator~Audit Actions~Credits~Customer~Dashboard~LocationOverall~MyPrezence~Onboarde~aac36c5a","Activated~Administrator~Audit Actions~Credits~Customer~LocationOverall~MyPrezence~Onboarded~Prezence~7f307219":"Activated~Administrator~Audit Actions~Credits~Customer~LocationOverall~MyPrezence~Onboarded~Prezence~7f307219","Activated~Credits~Customer~Dashboard~Onboarded~Prospect~Transactions":"Activated~Credits~Customer~Dashboard~Onboarded~Prospect~Transactions","Activated":"Activated","Credits":"Credits","Customer":"Customer","Onboarded":"Onboarded","Prospect":"Prospect","Transactions":"Transactions","Administrator":"Administrator","Audit Actions":"Audit Actions","Dashboard~releaseView":"Dashboard~releaseView","releaseView":"releaseView","LocationOverall":"LocationOverall","MyPrezence":"MyPrezence","Prezence":"Prezence","Printed":"Printed","Produced":"Produced","Referrals":"Referrals","Resolved Swipes":"Resolved Swipes","SalesRep":"SalesRep","Dashboard":"Dashboard","Main":"Main"}[chunkId]||chunkId) + "." + {"Activated~Administrator~Audit Actions~Credits~Customer~Dashboard~LocationOverall~Main~MyPrezence~Onb~9d88553d":"01cf6fd8","Activated~Administrator~Audit Actions~Credits~Customer~Dashboard~LocationOverall~MyPrezence~Onboarde~aac36c5a":"f918d7d1","Activated~Administrator~Audit Actions~Credits~Customer~LocationOverall~MyPrezence~Onboarded~Prezence~7f307219":"cf3d7027","Activated~Credits~Customer~Dashboard~Onboarded~Prospect~Transactions":"31d6cfe0","Activated":"9a986888","Credits":"df9d9a7c","Customer":"9a986888","Onboarded":"9a986888","Prospect":"9a986888","Transactions":"eeed5c67","Administrator":"fd5e64b0","Audit Actions":"df9d9a7c","Dashboard~releaseView":"98de82f2","releaseView":"e8a2a106","LocationOverall":"31d6cfe0","MyPrezence":"df9d9a7c","Prezence":"df9d9a7c","Printed":"df9d9a7c","Produced":"df9d9a7c","Referrals":"df9d9a7c","Resolved Swipes":"8fc01e22","SalesRep":"15811d07","Dashboard":"41923d9f","Main":"0df9c61f","chunk-41e00dab":"ef6640e5","chunk-2bbf3d76":"31d6cfe0","chunk-2d0a4d8f":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
